<script lang="ts" setup>
const props = defineProps({
  link: {
    required: true,
    type: String,
  },
  slug: {
    required: true,
    type: String,
  },
});

const encodedPermalink = computed(() => encodeURIComponent(props.link));

const encodedTSlug = computed(() => encodeURIComponent(props.slug));
</script>

<template>
  <ul
    class="list-none md:absolute md:left-0 md:top-0 md:w-[26px] flex items-center md:block -mb-3"
  >
    <li class="mr-3 mb-3">
      <a
        :href="`https://www.facebook.com/sharer/sharer.php?u=${encodedPermalink}`"
        target="_blank"
        rel="noopener noreferrer"
        class="share icon-main-facebook size-[26px] rounded-full border border-nl-green-100 text-nl-green-100 flex items-center justify-center hover:text-nl-green-200 hover:border-nl-green-200 transition duration-300 ease-linear mx-auto"
      />
    </li>
    <li class="mr-3 mb-3">
      <a
        :href="`https://twitter.com/intent/tweet?url=${encodedPermalink}&text=${encodedTSlug}`"
        target="_blank"
        rel="noopener noreferrer"
        class="share icon-main-twitter size-[26px] rounded-full border border-nl-green-100 text-nl-green-100 flex items-center justify-center hover:text-nl-green-200 hover:border-nl-green-200 transition duration-300 ease-linear mx-auto"
      />
    </li>
    <li class="mr-3 mb-3">
      <a
        :href="`https://www.pinterest.com/pin/create/button/?url=${encodedPermalink}&title=${encodedTSlug}`"
        target="_blank"
        rel="noopener noreferrer"
        class="share icon-main-pinterest size-[26px] rounded-full border border-nl-green-100 text-nl-green-100 flex items-center justify-center hover:text-nl-green-200 hover:border-nl-green-200 transition duration-300 ease-linear mx-auto"
      />
    </li>
    <li class="mr-3 mb-3">
      <a
        :href="`mailto:?body=${link}`"
        target="_blank"
        rel="noopener noreferrer"
        class="icon-main-mail size-[26px] rounded-full border border-nl-green-100 text-nl-green-100 flex items-center justify-center hover:text-nl-green-200 hover:border-nl-green-200 transition duration-300 ease-linear mx-auto"
      />
    </li>
  </ul>
</template>
